export default import.meta.ROLLDOWN_FILE_URL_5y5u0t2cm0pZnJCtI27VXQ